import { BaseModel } from '../../_base/crud';

export class GConfig extends BaseModel {
  section: string;
  name: string;
  identifier: string;
  value: string;
}
